module.exports = __webpack_public_path__ + "fonts/ALSRubl.woff?57df8d57b2565320105e55b617a094c7";